<template>
    <div class="container-fluid">
        <Breadcrumb title="Add SpamTrap MX" v-bind:button-show="false" v-show="!$route.params.id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-show="loading">
                <Preloader v-bind:class="{preloader: loading}"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">SpamTrap MX info</h4>
                        <SpamMxForm @hidePreloader="hidePreloader"></SpamMxForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import SpamMxForm from './forms/SpamMxForm';

    export default {
        name: 'SpamMx',
        components: {SpamMxForm, Preloader, Breadcrumb},
        data() {
            return {
                loading: false
            }
        },
        mounted() {
            if (this.$route.params.id) {
                this.loading = true;
            }
        },
        methods: {
            hidePreloader(value) {
                this.loading = !value
            }
        }
    }
</script>

<style scoped>

</style>